import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IAuthSlice {
  signInUrl: string | null;
  getSignInUrlLoading: boolean;
  getSignInUrlError: string | null;
  isSignInInProgress: boolean;
  signOutUrl: string | null;
  getSignOutUrlLoading: boolean;
  getSignOutUrlError: string | null;
}

const initialState: IAuthSlice = {
  signInUrl: null,
  getSignInUrlLoading: false,
  getSignInUrlError: null,
  isSignInInProgress: false,
  signOutUrl: null,
  getSignOutUrlLoading: false,
  getSignOutUrlError: null
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    getSignInUrl: (state) => {
      state.getSignInUrlLoading = true;
      state.isSignInInProgress = true;
    },
    getSignInUrlSuccess: (state, action: PayloadAction<string>) => {
      state.getSignInUrlLoading = false;
      state.signInUrl = action.payload;
    },
    getSignInUrlFail: (state, action: PayloadAction<string>) => {
      state.getSignInUrlLoading = false;
      state.isSignInInProgress = false;
      state.getSignInUrlError = action.payload;
    },
    getSignOutUrl: (state) => {
      state.getSignOutUrlLoading = true;
    },
    getSignOutUrlSuccess: (state, action: PayloadAction<string>) => {
      state.signOutUrl = action.payload;
      state.getSignOutUrlLoading = false;
    },
    getSignOutUrlFail: (state, action: PayloadAction<string>) => {
      state.getSignOutUrlLoading = false;
      state.getSignOutUrlError = action.payload;
    }
  }
});

export const { actions: authActions, reducer: authReducer } = authSlice;
